module.exports = __webpack_public_path__ + "media/honey-icons/icon-toaster-839a3d69.svg";